import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-8eac2d52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-wrapper" }
const _hoisted_2 = { class: "user-box d-flex flex-column align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = { class: "menu-box" }
const _hoisted_6 = ["aria-expanded", "data-bs-toggle", "data-bs-target", "aria-controls"]
const _hoisted_7 = { class: "left-container" }
const _hoisted_8 = {
  key: 0,
  class: "right-container"
}
const _hoisted_9 = ["id"]

import { reactive, computed, onMounted, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import _ from 'lodash';
  import { getMineMenus } from '@/constants';
  import { Menu } from '@/types/menu';
  import { IUser } from '@/types/user';
  import { authStore } from '@/stores';

  interface EmitsType {
    (e: 'trigger', value: boolean): void
    (e: 'change'): void
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["trigger", "change"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'trigger', value: boolean): void
    (e: 'change'): void
  }), expose: any, slots: any, attrs: any }) {

  const route = useRoute();
  const router = useRouter();
  const collapseMap = reactive<{[propName: string]: boolean}>({});
  const defaultExpandedId = ref('');

  const menus = computed(() => {
    return getMineMenus();
  });
  const user = computed<IUser>(() => {
    return authStore.user || {};
  });

  

  const checkActive = (item: Menu) => {
    if (!item.to) {
      return;
    }
    return route.name === router.resolve(item.to).name;
  };

  function checkCollapse(item: Menu) {
    return item.children && item.children.length;
  }

  function checkExpanded() {
    const activeItem = menus.value.find(item => {
      return collapseMap[item.id] = _.some(item.children, checkActive);
    });
    // 使用 defaultExpandedId 防止展开收起没有动画
    defaultExpandedId.value = _.get(activeItem, 'id', '0');
    return activeItem;
  }

  function handleTriggerCollapse(item: Menu) {
    const { id } = item;
    collapseMap[id] = !Boolean(collapseMap[id]);
    if (!checkActive(item)) {
      emits('change');
    }
    emits('trigger', collapseMap[id]);
  };

  onMounted(() => {
    checkExpanded();
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(user).avatar || require('@/assets/icon/header2.png'),
        class: "header"
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(user).profile?.nick_name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "menu"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["title-box", { active: checkActive(item) }]),
            "aria-expanded": _unref(collapseMap)[item.id],
            "data-bs-toggle": checkCollapse(item) ? 'collapse' : '',
            "data-bs-target": `#${item.id}`,
            "aria-controls": item.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.to ? 'router-link' : 'div'), {
                to: item.to || '',
                class: "router-link",
                onClick: ($event: any) => (!item.children && handleTriggerCollapse(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            ]),
            (checkCollapse(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: _normalizeClass(["arrow", { rotate: _unref(collapseMap)[item.id] }])
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6),
          (checkCollapse(item))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: item.id,
                class: _normalizeClass(["content-box collapse", { show: defaultExpandedId.value === item.id }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (menu, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(["content-item", { active: checkActive(menu) }])
                  }, [
                    _createVNode(_component_router_link, {
                      to: menu.to,
                      class: "router-link",
                      onClick: ($event: any) => (handleTriggerCollapse(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menu.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"])
                  ], 2))
                }), 128))
              ], 10, _hoisted_9))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})